/** Minutes in a day; a scheduling barrier at or beyond this crosses midnight into the next day. */
export const MINUTES_PER_DAY = 1440;

/** Parses a "HH:mm" or "HH:mm:ss" time string into minutes-of-day, or null when it cannot be parsed. */
export function parseTimeToMinutes(time: string): number | null {
  if (!time) {
    return null;
  }
  // Accept "HH:mm" and "HH:mm:ss" (Liva returns start times with seconds).
  const match = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(time.trim());
  if (!match) {
    return null;
  }
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > 23 || minutes > 59) {
    return null;
  }
  return (hours * 60) + minutes;
}

/** Formats minutes-of-day back into a "HH:mm" string. */
export function formatMinutes(totalMinutes: number): string {
  const normalized = (((totalMinutes % 1440) + 1440) % 1440);
  const hours = Math.floor(normalized / 60);
  const minutes = normalized % 60;
  return `${`${hours}`.padStart(2, '0')}:${`${minutes}`.padStart(2, '0')}`;
}
